import React, { useEffect, useState } from "react";

import Colors from "../../utility/Colors.js";

import FilterListIcon from "@mui/icons-material/FilterList";
import VisibilityIcon from "@mui/icons-material/Visibility";
import GetAppIcon from "@mui/icons-material/GetApp";
import {
  Typography,
  Box,
  Button,
  Grid,
  Card,
  Badge,
  Tooltip,
  Avatar,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { GridActionsCellItem } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import AdvanceSearchModal from "./AdvanceSearchModal.js";
import Methods, { handleLogOut } from "../../utility/Methods.js";
import { transform } from "typescript";
import {
  downloadAwardExcelThunk,
  filterCasesThunk,
  getAbhaCardThunk,
  getStatsForDashboardThunk,
} from "./reducer/thunk.js";
import { getCaseThunk } from "../viewDetails/reducer/thunk.js";
import constants from "../../common/constants.js";
import Backdrop from "../../components/backdrop/index.tsx";
import FileSaver from "file-saver";
import SnackbarComponent from "../../components/snackbar/index.tsx";
import { getSession } from "../../utility/SessionManager.js";
import {
  resetDownloadAwardExcel,
  resetGetAbhaCard,
  resetGetAbhaCardPhr,
} from "./reducer/slice.js";
import DownloadIcon from "@mui/icons-material/Download";
import PrintIcon from "@mui/icons-material/Print";

import { saveAs } from "file-saver";
import axios from "axios";
import { resetEnrolByAadhar } from "../Register/reducer/abhaAadhar/slice.js";
import { resetAbhaVerifyOtp } from "../Login/reducer/slice.js";

const Dashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const source = location.state?.source;

  const role = Methods.getRole();
  const [userDetails, setUserDetails] = useState(null);
  const [phrCardImage, setPhrCardImage] = useState("");

  const [abhaToken, setAbhaToken] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState({
    open: false,
    severity: "",
    message: "",
  });
  const verifyOtp = useSelector((state) => state.login.verifyOtp);
  const {
    status: verifyOtpStatus,
    data: verifyOtpData,
    error: verifyOtpError,
  } = verifyOtp;

  const abhaVerifyOtp = useSelector((state) => state.login.abhaVerifyOtp);
  const {
    status: abhaVerifyOtpStatus,
    data: abhaVerifyOtpData,
    error: abhaVerifyOtpError,
  } = abhaVerifyOtp;
  const getAbhaCard = useSelector((state) => state.userDetails.getAbhaCard);
  const {
    status: getAbhaCardStatus,
    data: getAbhaCardData,
    error: getAbhaCardError,
  } = getAbhaCard;
  const getAbhaCardPhr = useSelector(
    (state) => state.userDetails.getAbhaCardPhr
  );
  const {
    status: getAbhaCardPhrStatus,
    data: getAbhaCardPhrData,
    error: getAbhaCardPhrError,
  } = getAbhaCardPhr;

  console.log("source", source);

  const handleShowSnackbar = (severity, message) => {
    setSnackbarOpen({
      open: true,
      severity: severity,
      message: message,
    });
  };
  const handleSnackClose = () => {
    setSnackbarOpen({
      open: "",
      severity: "",
      message: "",
    });
  };

  useEffect(() => {
    if (source === "abhaAddress" && abhaToken) {
      const fileUrl = `${process.env.REACT_APP_ABHA_BACKEND_URL}/phr/web/login/profile/abha/phr-card`;

      axios
        .get(fileUrl, {
          responseType: "arraybuffer",
          headers: {
            Authorization: `Bearer ${abhaToken}`,
            Accept: "*/*",
            "Accept-Encoding": "gzip, deflate, br",
            connection: "keep-alive",
          },
        })
        .then((res) => {
          const blob = new Blob([res.data], { type: "image/png" });
          const blobUrl = URL.createObjectURL(blob);
          setPhrCardImage(blobUrl);
        })
        .catch((error) => {
          console.error("PHR Card display error:", error);
          handleShowSnackbar("error", error.message);
        });
    }
  }, [source, abhaToken]);

  useEffect(() => {
    if (source === "abhaAddress") {
      console.log("inside", source);
      if (abhaVerifyOtpStatus === "succeeded") {
        console.log(
          "response",
          JSON.parse(Methods.decryptData(abhaVerifyOtpData?.data))
        );

        let decData = JSON.parse(Methods.decryptData(abhaVerifyOtpData?.data));
        let finalData = decData.response;
        console.log("abhaVerifyOtp finalData", finalData);

        setAbhaToken(finalData?.tokens?.token);
        // navigate(constants.PATH_DASHBOARD);
      } else if (abhaVerifyOtpStatus === "failed") {
        handleShowSnackbar("error", abhaVerifyOtpError?.error?.errorMessage);
      }
    } else {
      if (verifyOtpStatus === "succeeded") {
        console.log(
          "response",
          JSON.parse(Methods.decryptData(verifyOtpData?.data))
        );
        let decData = JSON.parse(Methods.decryptData(verifyOtpData?.data));
        console.log("verifyOtp data", decData.response);
        let finalData = decData.response;
        setUserDetails(finalData?.accounts?.[0]);
        // navigate(constants.PATH_DASHBOARD);
      } else if (verifyOtpStatus === "failed") {
        handleShowSnackbar("error", verifyOtpError?.error?.errorMessage);
      }
    }
  }, [verifyOtpStatus, abhaVerifyOtpData]);

  // Convert base64 image if present
  const imgSrc = userDetails?.profilePhoto
    ? `data:image/jpeg;base64,${userDetails?.profilePhoto}`
    : "";

  useEffect(() => {
    if (getAbhaCardStatus === "succeeded") {
      console.log(
        "Data type:",
        Object.prototype.toString.call(getAbhaCardData)
      );

      const blob = new Blob([getAbhaCardData], { type: "application/pdf" });
      saveAs(blob, "ABHA_Card.pdf");

      handleShowSnackbar("success", "PDF downloaded successfully!");
    } else if (getAbhaCardStatus === "failed") {
      handleShowSnackbar("error", getAbhaCardError?.error?.errorMessage);
    }
  }, [getAbhaCardStatus]);

  const getAuthToken = () => {
    return Methods.decryptData(
      getSession(window, constants.SS_KEY_GROUP_ACCESS_TOKEN)
    );
  };

  const handleFileDownload = () => {
    const authToken = getAuthToken().replace(/^"|"$/g, "");
    const fileUrl = `${process.env.REACT_APP_ABHA_BACKEND_URL}/profile/account/abha-card`;

    axios
      .get(fileUrl, {
        responseType: "arraybuffer",
        headers: {
          Authorization: `Bearer ${authToken}`,
          Accept: "image/png",
        },
      })
      .then((res) => {
        console.log("resss", res);
        console.log("Response size:", res.data.byteLength);
        const blob = new Blob([res.data]);
        saveAs(blob, "ABHA_Card.png");
        handleShowSnackbar("success", "PDF downloaded successfully!");
      })
      .catch((error) => {
        console.error("Download error:", error);
        handleShowSnackbar("error", error);
      });
  };

  const handlePhrCardDownload = () => {
    const fileUrl = `${process.env.REACT_APP_ABHA_BACKEND_URL}/phr/web/login/profile/abha/phr-card`;

    axios
      .get(fileUrl, {
        responseType: "arraybuffer",
        headers: {
          Authorization: `Bearer ${abhaToken}`,
          Accept: "image/png",
        },
      })
      .then((res) => {
        const blob = new Blob([res.data], { type: "image/png" });
        saveAs(blob, "ABHA_PHR_Card.png");
        handleShowSnackbar("success", "PHR Card downloaded successfully!");
      })
      .catch((error) => {
        console.error("PHR Card download error:", error);
        handleShowSnackbar("error", error.message);
      });
  };

  const handlePhrCardPrint = async () => {
    const fileUrl = `${process.env.REACT_APP_ABHA_BACKEND_URL}/phr/web/login/profile/abha/phr-card`;

    try {
      const res = await axios.get(fileUrl, {
        responseType: "arraybuffer",
        headers: {
          Authorization: `Bearer ${abhaToken}`,
          Accept: "image/png",
        },
        // Optional: timeout, withCredentials, etc., as needed
      });

      // Validate content-type (defense-in-depth)
      const contentType = (res.headers && res.headers["content-type"]) || "";
      if (!contentType.startsWith("image/")) {
        throw new Error(`Unexpected content-type: ${contentType}`);
      }

      const blob = new Blob([res.data], { type: "image/png" });
      const blobUrl = URL.createObjectURL(blob);

      // Open a new window with appropriate features to prevent opener attacks
      const printWindow = window.open(
        "about:blank",
        "_blank",
        "noopener,noreferrer"
      );

      if (printWindow) {
        printWindow.opener = null;
      }

      if (!printWindow) {
        console.error("Failed to open print window.");
        handleShowSnackbar("error", "Failed to open print window.");
        URL.revokeObjectURL(blobUrl);
        return;
      }

      // Build DOM safely (no document.write, no inline JS)
      const doc = printWindow.document;
      const html = doc.documentElement;
      const head = doc.createElement("head");
      const body = doc.createElement("body");

      const title = doc.createElement("title");
      title.textContent = "Print ABHA Card";

      const style = doc.createElement("style");
      style.textContent = `
      body { margin: 0; display: flex; justify-content: center; align-items: center; height: 100vh; }
      img { max-width: 100%; max-height: 100%; }
    `;

      const img = doc.createElement("img");
      img.alt = "ABHA Card";
      img.src = blobUrl;

      head.appendChild(title);
      head.appendChild(style);
      body.appendChild(img);

      // Assemble the document
      html.replaceChildren(head, body);

      // Print only when the image loads fully (no inline handlers)
      img.addEventListener("load", () => {
        // Give layout a tick, then print
        setTimeout(() => {
          printWindow.focus();
          printWindow.print();
        }, 0);
      });

      // Close window and revoke URL after print completes
      // Note: Some browsers fire 'afterprint' only on the window
      printWindow.addEventListener("afterprint", () => {
        // Cleanup
        URL.revokeObjectURL(blobUrl);
        printWindow.close();
      });

      // Fallback cleanup if afterprint doesn't fire
      setTimeout(() => {
        URL.revokeObjectURL(blobUrl);
      }, 60_000);
    } catch (error) {
      console.error("Print error:", error);
      handleShowSnackbar("error", error?.message || "Print failed");
    }
  };

  const handleFilePrint = () => {
    const authToken = getAuthToken().replace(/^"|"$/g, "");
    const fileUrl = `${process.env.REACT_APP_ABHA_BACKEND_URL}/profile/account/abha-card`;

    axios
      .get(fileUrl, {
        responseType: "arraybuffer",
        headers: {
          Authorization: `Bearer ${authToken}`,
          Accept: "image/png",
        },
      })
      .then((res) => {
        const blob = new Blob([res.data], { type: "image/png" });
        const blobUrl = URL.createObjectURL(blob);

        const printWindow = window.open("", "_blank", "noopener,noreferrer");
        if (printWindow) {
          printWindow.opener = null;
          const doc = printWindow.document;
          const html = doc.documentElement;
          const head = doc.createElement("head");
          const body = doc.createElement("body");

          const title = doc.createElement("title");
          title.textContent = "Print ABHA Card";

          const style = doc.createElement("style");
          style.textContent = `
                body { margin: 0; display: flex; justify-content: center; align-items: center; height: 100vh; }
                img { max-width: 100%; max-height: 100%; }
              `;

          const img = doc.createElement("img");
          img.src = blobUrl;
          img.alt = "ABHA Card";

          head.appendChild(title);
          head.appendChild(style);
          body.appendChild(img);

          // Build the document
          html.replaceChildren(head, body);

          // Print handler
          img.onload = () => {
            printWindow.print();
            printWindow.onafterprint = () => printWindow.close();
          };

          doc.close();
        } else {
          console.error("Failed to open print window.");
        }
      })
      .catch((error) => {
        console.error("Print error:", error);
        handleShowSnackbar("error", error);
      });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    //!to reset next button redirection functionality
    return () => {
      dispatch(resetAbhaVerifyOtp());
      dispatch(resetEnrolByAadhar());
      dispatch(resetGetAbhaCardPhr());
      dispatch(resetGetAbhaCard());
    };
  }, []);

  return (
    <div style={{ width: "100%" }}>
      <Card
        sx={{
          width: "fullWidth",
          marginTop: "10px",
          minHeight: "100vh",
          borderRadius: "10px",
          p: 2,
          boxShadow: `0 2px 5px ${Colors.DARK_GREY}`,
          "&:hover": {
            boxShadow: "#008080 0px 2px 5px",
          },
        }}
      >
        {/* {downloadAwardExcelStatus === "pending" ? <Backdrop /> : null}{" "} */}
        <Grid sx={{ display: "flex", justifyContent: "center" }}>
          <Box sx={{ width: "100%", maxWidth: 620, my: 3, px: 2 }}>
            <Typography
              variant="h6"
              sx={{
                mb: 2,
                fontWeight: "bold",
                textAlign: "center",
                letterSpacing: "0.5px",
              }}
            >
              Welcome, {userDetails?.name}
            </Typography>
            <Grid sx={{ display: "flex", justifyContent: "end" }}>
              <Button
                sx={{ color: "#f5841f", mr: 2 }}
                startIcon={<DownloadIcon />}
                onClick={(e) => {
                  e.preventDefault();
                  if (source === "abhaAddress") {
                    handlePhrCardDownload();
                  } else {
                    handleFileDownload();
                  }
                }}
              >
                Download ABHA Card
              </Button>
              <Button
                sx={{ color: "#f5841f" }}
                startIcon={<PrintIcon />}
                onClick={(e) => {
                  e.preventDefault();
                  if (source === "abhaAddress") {
                    handlePhrCardPrint();
                  } else {
                    handleFileDownload();
                  }
                  handleFilePrint();
                }}
              >
                Print ABHA Card
              </Button>
            </Grid>
            {source !== "abhaAddress" ? (
              <Box
                sx={{
                  border: "1px solid #ccc",
                  borderRadius: 2,
                  background: "#fff",
                  p: 2,
                  width: "100%",
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 600,
                    mb: 2,
                    fontSize: "1.18rem",
                    letterSpacing: "0.2px",
                    background: "#0284c9",
                    p: 2,
                    borderRadius: "5px",
                    color: "#fff",
                  }}
                >
                  Ayushman Bharat Health Account (ABHA)
                </Typography>
                <Grid container alignItems="center">
                  {/* Profile Pic */}
                  <Grid
                    item
                    xs={4}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    <img
                      src={imgSrc}
                      alt={userDetails?.name}
                      style={{
                        width: 150,
                        height: 180,
                        border: "1.5px solid #e0e0e0",
                        borderRadius: "5px",
                        objectFit: "cover",
                        borderRadius: 3,
                      }}
                    />
                  </Grid>
                  {/* Info Fields */}
                  <Grid item xs={8}>
                    <Box sx={{ pl: 8 }}>
                      {/* Name */}
                      <Typography
                        sx={{
                          fontWeight: 600,
                          fontSize: "1.1rem",
                          mb: 0.5,
                          letterSpacing: "0.1px",
                        }}
                      >
                        {userDetails?.name}
                      </Typography>
                      {/* ABHA Number */}
                      <Typography
                        sx={{ fontWeight: 500, fontSize: "1.05rem", mb: 0.25 }}
                      >
                        <span style={{ color: "#67676F" }}>
                          <b>ABHA Number:</b>
                        </span>{" "}
                        <span style={{ letterSpacing: "2px" }}>
                          <b>{userDetails?.ABHANumber}</b>
                        </span>
                      </Typography>

                      {/* ABHA Address */}
                      <Typography
                        sx={{ fontWeight: 500, fontSize: "1.05rem", mb: 0.25 }}
                      >
                        <span style={{ color: "#67676F" }}>
                          <b>ABHA Address:</b>
                        </span>{" "}
                        <span>
                          <b>
                            {userDetails?.preferredAbhaAddress
                              ? userDetails?.preferredAbhaAddress
                              : userDetails?.phrAddress?.[0]}
                          </b>
                        </span>
                      </Typography>
                      {/* Gender, DOB, Mobile */}
                      <Grid
                        container
                        spacing={2}
                        sx={{ mt: 0.5, mb: 0.25, maxWidth: 360 }}
                      >
                        <Grid item xs={4}>
                          <Typography
                            sx={{
                              fontWeight: 500,
                              fontSize: "1.05rem",
                              mb: 0.25,
                            }}
                          >
                            <span style={{ color: "#67676F" }}>
                              <b>Gender:</b>
                            </span>{" "}
                            <span>
                              <b>
                                {userDetails?.gender === "M"
                                  ? "Male"
                                  : userDetails?.gender === "F"
                                  ? "Female"
                                  : ""}
                              </b>
                            </span>
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography
                            sx={{
                              fontWeight: 500,
                              fontSize: "1.05rem",
                              mb: 0.25,
                            }}
                          >
                            <span style={{ color: "#67676F" }}>
                              <b>Date of Birth:</b>
                            </span>{" "}
                            <span>
                              <b>{userDetails?.dob}</b>
                            </span>
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography
                            sx={{
                              fontWeight: 500,
                              fontSize: "1.05rem",
                              mb: 0.25,
                            }}
                          >
                            <span style={{ color: "#67676F" }}>
                              <b>Mobile:</b>
                            </span>{" "}
                            <span>
                              <b>{userDetails?.mobile}</b>
                            </span>
                          </Typography>
                        </Grid>
                      </Grid>

                      {/* Status */}
                      <Typography
                        sx={{ fontWeight: 500, fontSize: "1.05rem", mb: 0.25 }}
                      >
                        <span style={{ color: "#67676F" }}>
                          <b>Status:</b>
                        </span>{" "}
                        <span>
                          <b>{userDetails?.status}</b>
                        </span>
                      </Typography>

                      {/* Verified Status */}
                      <Typography
                        sx={{ fontWeight: 500, fontSize: "1.05rem", mb: 0.25 }}
                      >
                        <span style={{ color: "#67676F" }}>
                          <b>Verified Status:</b>
                        </span>{" "}
                        <span>
                          <b>{userDetails?.verifiedStatus}</b>
                        </span>
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            ) : source === "abhaAddress" && phrCardImage ? (
              <>
                <Grid
                  container
                  justifyContent="center"
                  alignItems="center"
                  sx={{ mt: 2 }}
                >
                  <Grid item xs={12} sm={10} md={8} lg={6}>
                    <Box
                      sx={{
                        textAlign: "center",
                        width: "100%",
                        p: 2,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <Typography variant="h6" sx={{ mb: 2 }}>
                        ABHA Card Preview
                      </Typography>
                      <Box
                        component="img"
                        src={phrCardImage}
                        alt="ABHA PHR Card"
                        sx={{
                          height: { xs: "auto", md: "400px" },
                          width: "100%",
                          maxWidth: "100%",
                          borderRadius: "8px",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                        }}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </>
            ) : null}
          </Box>
        </Grid>
      </Card>
      <SnackbarComponent
        message={snackbarOpen?.message}
        isOpen={snackbarOpen?.open}
        purpose={snackbarOpen?.severity}
        handleClick={handleSnackClose}
      />
    </div>
  );
};

export default Dashboard;
